import React, { useEffect, useState, useRef } from 'react';
import AdminLayout from '../../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Add() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [loaded, setLoaded] = useState(false);
  const [selectionType, setSelectionType] = useState('one');

  const [formData, setFormData] = useState({
    name: '',
    programObjectiveIds: [],
  });

  const [objectives, setObjectives] = useState([]);
  const focusInputRef = useRef(null);
  const location = useLocation();
  const currentPath = location?.pathname || '';

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') navigate('/');

    if (focusInputRef.current) focusInputRef.current.focus();

    // Fetch objective list
    axios
      .get(`${apiUrl}/api/program-objective/`, {
        headers: { Authorization: token },
      })
      .then((res) => {
        const options = res.data.programObjectives.map((item) => ({
          value: item.id,
          label: item.objectiveName,
        }));
        setObjectives(options);
      })
      .catch((err) => {
        toast.error('Failed to fetch objectives');
        console.error(err);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoaded(true);

    const payload = {
      name: formData.name,
      programObjectiveIds: formData.programObjectiveIds.map((obj) => obj.value),
    };

    axios
      .post(`${apiUrl}/api/program/`, payload, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        toast.success('Program added successfully');
        setLoaded(false);
        setFormData({ name: '', programObjectiveIds: [] });
        focusInputRef.current?.focus();

        if (selectionType === 'one' && currentPath === '/ProgramAdd') {
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/ProgramAdd') {
              navigate('/ProgramList');
            }
          }, 3000);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || 'Error saving data');
        if (err.response?.status === 401) navigate('/');
        setLoaded(false);
      });
  };

  return (
    <AdminLayout ac15="active" dr="true">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/ProgramList">View Program</Link>
              </li>
              <li className="breadcrumb-item active">Add New Program</li>
            </ol>
          </nav>
        </div>

        <section className="section col-lg-12">
          <div className="row">
            <div className="card">
              <div className="card-body mt-5 mx-3">
                <form onSubmit={handleSubmit}>
                  {/* Details of subject */}
                  <div className="container">
                    <div className="row row-cols-1">
                      <div className="col-6">
                        <div className="form-floating mb-2">
                          <input
                            ref={focusInputRef}
                            className="form-control"
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={(e) =>
                              setFormData({ ...formData, name: e.target.value })
                            }
                            placeholder="Enter program name"
                            required
                          />
                          <label className="form-label" htmlFor="txtGrNo">
                            Program Name <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="form-floating mb-2">
                          <Select
                            isMulti
                            name="programObjectiveIds"
                            placeholder="Select Program Objectives"
                            options={objectives}
                            value={formData.programObjectiveIds}
                            onChange={(selected) =>
                              setFormData({
                                ...formData,
                                programObjectiveIds: selected,
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Submit Button */}
                  <div className="row">
                    <div className="d-flex justify-content-between ">
                      <div className="p-2 mx-2 bd-highlight ">
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input recode-switch"
                            type="checkbox"
                            id="selectionSwitch"
                            checked={selectionType === 'many'} // Toggle the state
                            onChange={() =>
                              setSelectionType(
                                selectionType === 'many' ? 'one' : 'many'
                              )
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="selectionSwitch"
                          >
                            {selectionType === 'many'
                              ? 'Many Subjects Add'
                              : 'One Subject Add'}
                          </label>
                        </div>
                      </div>

                      <div className="p-2 mx-1 bd-highlight">
                        <button
                          type="button"
                          className="btn btn-primary px-3"
                          onClick={() => navigate(-1)}
                        >
                          <i className="bi bi-arrow-bar-left"></i> Back
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary px-4 mx-1"
                          disabled={loaded}
                        >
                          {loaded ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>{' '}
                              Wait...
                            </>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <ToastContainer position="top-center" />
              </div>
            </div>
          </div>
        </section>
      </main>
    </AdminLayout>
  );
}
